import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import './index.css';
import cssVars from 'css-vars-ponyfill';
import '@app/yup.config';

import { registerLocale } from 'react-datepicker';
import pt from 'date-fns/locale/pt';
import Router from './routes/Router';

// Redux
import store from './store';

// Compatibilidade
import reportWebVitals from './reportWebVitals';

cssVars();

registerLocale('pt', pt);

Modal.setAppElement('#root');

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <BrowserRouter>
        <ToastContainer autoClose={5000} />
        <Router />
      </BrowserRouter>
    </React.StrictMode>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
